import { Droppable } from 'react-beautiful-dnd';
import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import { FxTranslate } from '../../core/translate';
import { GetStyleEstado } from '../../services/operaciones';
import { ICardInfo } from './';
import CardComponent from './card.component';
import styles from './grupo.module.scss';

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  id: number;
  title?: string;
  /** indica si el grupo debe estar bloqueado */
  block?: boolean;

  cards?: ICardInfo[];

  /** cantidad de tarjetas ocultas */
  hiddenCards?: number;

  /** Ocurre cuando se hace click sobre la tarjeta para abrirla */
  onOpen: (data?: ICardInfo) => void;

  /** Ocurre cuando se pide ver mas tarjetas */
  onShowMoreCards: (idgrupo: number, cant: number) => void;
}

function BoardComponent({ storage, t, 
  id, title, block,
  cards, hiddenCards,
  onOpen, onShowMoreCards,
} : IProps) {
  return <div className={`${styles["container"]} ${block && styles["container-block"]}`}>
    <div className={styles["title"]}>
      {title}
    </div>
    <Droppable droppableId={`${id}`} isDropDisabled={block} >
      {(provided, snapshot) => (
        <div className={styles["cards"]} {...provided.droppableProps} ref={provided.innerRef} >

          {cards?.map((card, index) => 
            <CardComponent key={`${card.id}`} t={t} index={index} data={card} onOpen={onOpen} />
          )}

          {provided.placeholder}
          
          {!!hiddenCards && <>
            <div className={styles["more-cards"]} style={GetStyleEstado(id)} onClick={() => onShowMoreCards(id, 5)}>
              <i className="fas fa-plus"></i> {t("Grupo.ShowMore", { add: hiddenCards > 5 ? 5 : hiddenCards, of: hiddenCards })}
            </div>
          </>}
        </div>
      )}
    </Droppable>
  </div>;
}

export default connect((s:any) => ({ storage:s.main }))(BoardComponent);
